module.exports = __webpack_public_path__ + "static/img/bg.35e56dea.jpg";